/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import React from 'react';
import { useTranslation } from 'react-i18next';

// Packages

// UI lib components

// UI local components

// styles
import './index.scss';

// assets
import addressLogo from '../../../images/contactPage/address.svg';
import emailLogo from '../../../images/contactPage/email.svg';
import phonLogo from '../../../images/contactPage/phone.svg';

/* -------------------------------------------------------------------------- */
/*                                    Page                                    */
/* -------------------------------------------------------------------------- */

function ContactInfos() {
  const icons = [emailLogo, addressLogo, phonLogo];
  /* ********************************** HOOKS ********************************* */

  // Localization
  const { t } = useTranslation();
  const { list } = t('infos', {
    returnObjects: true,
  });

  /* ******************************** RENDER HELPERS ******************************* */

  /* ******************************** RENDERING ******************************* */
  return (
    <div className="vw-40 vw-30-med bg-blue flex justify-center contact-infos px-30 px-15-med">
      <div className="flex flex-column pt-120 pt-36-m">
        {list.map(({ label, value }, index) => (
          <div className="f-v-center item">
            <img
              src={icons[index]}
              alt=""
              className="h-80-med w-80-med ob-contain"
            />
            <div className="flex flex-column ms-30 ms-15-med">
              <span className="f24 f20-med f16-m text-white">{label}</span>
              <span className="f24 f20-med f16-m bold text-white text-wrap">
                {value}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ContactInfos;
